'use strict';

import Vue from 'vue';
import config from 'client/config';
import store from 'client/store';
import { saveAs } from 'file-saver';

const {
  Parser,
  transforms: { unwind },
  formatters: { number: numberFormatter },
} = require('json2csv');

const decimalSymbols = {
  en: '.',
  de: ',',
  fr: ',',
  nl: ',',
}

const moment = require('moment');

export default (function() {
  let a = document.createElement("a");
  document.body.appendChild(a);
  a.style.display = 'none';

  return {
    prepareReportData: function(eventDiscipline, sections = [], documentTitle = null) {
      const event = store.state.events.current
      const logo = eventDiscipline.logoUrl || event.logoUrl;
      const data = {
        title: eventDiscipline.name,
        subTitle: documentTitle,
        venue: event.venue,
        eventDate: (event.date_from ? moment(event.date_from.substring(0, 10), 'YYYY/MM/DD').format('DD/MM/YYYY')
        + (event.date_to ? ' - ' + moment(event.date_to.substring(0, 10), 'YYYY/MM/DD').format('DD/MM/YYYY') : '') : null),
        logo,
        timestamp: moment(Date.now()).format('DD/MM/YYYY - HH:mm'),
        copyright: eventDiscipline.copyright ? eventDiscipline.copyright : event.copyright,
        sections: sections,
        appUrl: 'http://localhost:8080',
      };

      return data;
    },

    prepareCustomizing: async function(eventDiscipline, report) {
      const event = store.state.events.current
      const organisation = store.getters.organisation(event.organisationId)

      switch (report.template.name) {
        case 'ScoreExpress': {
          report.template.chrome = {
            marginTop: '4.1cm',
            marginBottom: '1.6cm',
          }

          if (organisation.reports?.footer) {
            report.data.footerTemplate = organisation.reports.footer
            report.data.footerImage = organisation.reports?.footer
              ? organisation.reportFooterImage ?? organisation.reports.footerImage : undefined
            if (organisation.reports.footerSize) {
              report.template.chrome.marginBottom = organisation.reports.footerSize + "cm"
            }
          }
          if (organisation.reports?.header) {
            report.data.headerTemplate = organisation.reports.header;
            report.data.headerImage = organisation.reports?.header
              ? organisation.reportHeaderImage ?? organisation.reports.headerImage : undefined
            if (organisation.reports.headerSize) {
              report.template.chrome.marginTop = organisation.reports.headerSize + "cm"
            }
          }

          break
        }
        case 'certificate': {
          if (organisation.reports.certificate) {
            report.data.certificateTemplate = organisation.reports.certificate
          }
          if (organisation.reports.css) {
            report.data.customCss = organisation.reports.css
          }
          break
        }
        case 'bib': {
          if (organisation.reports.bib) {
            report.data.bibTemplate = organisation.reports.bib
          }
          if (organisation.reports.css) {
            report.data.customCss = organisation.reports.css
          }
          break
        }
      }
    },

    publishPDF: function(template, fileType, eventDiscipline, sections, documentTitle = null) {
      // slice the last section if it is a page break
      if (sections.length > 0 && sections[sections.length - 1].type === 'pagebreak') {
        sections.pop();
      }

      const data = this.prepareReportData(eventDiscipline, sections, documentTitle);
      const lang = Vue.i18n.locale.substring(0, 2);

      const filename = Vue.i18n.t('report.filename.' + fileType) + '.pdf';

      const report = {
        template: {
          name: template,
        },
        options: {
          language: lang,
        },
        data,
      }

      return this.prepareCustomizing(eventDiscipline, report).then(() => Vue.http.post(config.reporting, report, {
        responseType: 'blob'
      })).then((result) => {
        this.publishFile(result.body, filename);
      }, err => {
        console.log(err);
      });
    },

    publishReport: function(eventDiscipline, sections, type = 'results', documentTitle = null) {
      this.publishPDF('ScoreExpress', type, eventDiscipline, sections, documentTitle);
    },

    publishBIB: function(eventDiscipline, sections) {
      this.publishPDF('bib', 'bib', eventDiscipline, sections);
    },

    publishCertificates: function(eventDiscipline, sections) {
      this.publishPDF('certificate', 'awards', eventDiscipline, sections);
    },

    publishCSV2: function(data, fields, filename, unwindPaths = null, transformations = null) {
      let  transforms = transformations || [];
      if (unwindPaths) {
        transforms = [unwind({paths: unwindPaths}), ...transforms]
      }

      const lang = Vue.i18n.locale.substring(0, 2);
      let decimalSymbol = decimalSymbols[lang]

      const json2csvParser = new Parser({
        fields,
        transforms,
        delimiter: ';',
        formatters: {
          number: numberFormatter({separator: decimalSymbol, decimals: 3})
        }
      })
      const csv = json2csvParser.parse(data)
      if (! filename.endsWith('.csv')) {
        filename += '.csv'
      }
      this.publishFile(csv, filename, 'csv')
    },

    publishXML: function(data, template, filename) {
      const lang = Vue.i18n.locale.substring(0, 2);
      const report = {
        template: {
          name: template,
        },
        options: {
          language: lang,
        },
        data,
      }

      Vue.http.post(config.reporting, report, {
        responseType: 'blob'
      }).then((result) => {
        this.publishFile(result.body, filename, 'xml')
      }, err => {
        console.log(err)
      })
    },

    publishFile: function(content, name, type = 'pdf') {
      let dataType = null
      switch (type) {
        case 'pdf':
          dataType = 'application/pdf'
          break
        case 'csv':
          dataType = 'text/plain;charset=utf-8'
          break
        case 'xml':
          dataType = 'text/xml'
          break
      }

      let blob = new Blob([content], {type: dataType})
      saveAs(blob, name)
    }
  };
}());
